import React, { useState, useEffect, useContext } from "react";
import Header from "../../components/dashboard/header";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import SideMenu from "../student/SideMenu";
import Loader from "../../components/loader";
import SessionPopup from "../SessionPopup";
import SweetAlert from 'react-bootstrap-sweetalert';
import { ToastContainer } from 'react-toastify';
import { contentContext } from "../../context/contentContext";
import ShareDetailsContent from "./ShareDetailsContent";
import { useShareDetails } from "./useShareDetails";

const ViewShareHistory = () => {
    const { shareid } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();
    const { isRestricted } = useContext(contentContext);
    const { shareData, isLoading, showSessionPopup } = useShareDetails(shareid, state?.shareData);
    const [now, setNow] = useState(Date.now()); // ticks every minute so the countdown stays current

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        const timer = setInterval(() => setNow(Date.now()), 60000);
        return () => clearInterval(timer);
    }, []);

    const handleBack = () => {
        navigate("/sharedlinks", { state: { restoreListPage: true } });
    };

    // extend flow lives on the edit page
    const handleExtend = () => {
        navigate(`/sharedlinks/edit/${shareData?.shareid || shareid}`, { state: { shareData } });
    };

    return (
        <>
            {showSessionPopup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <SweetAlert show={!isLoading && !shareData && !showSessionPopup}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"Shared link not found"}
                    onConfirm={handleBack}
                >
                </SweetAlert>
                <div className="main-content user-management create-user" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">VIEW SHARED LINK</h4>
                                            <p className="menu-path" id="breadcrumb-path">
                                                <span>SHARED LINKS</span> / <b id="breadcrumb-action">VIEW SHARED LINK</b>
                                            </p>
                                        </div>
                                        <div>
                                            <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">BACK TO SHARED LINKS</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="create-user-block" id="create-user-block">
                                {!isLoading && shareData ? (
                                    <ShareDetailsContent
                                        shareData={shareData}
                                        shareid={shareid}
                                        now={now}
                                        canExtend={!isRestricted}
                                        onExtend={handleExtend}
                                    />
                                ) : (
                                    <div className="form-block" id="loading-block">
                                        <div className="tab-content p-3 text-muted">
                                            <div className="tab-pane active show" id="home1" role="tabpanel">
                                                <div className="row">
                                                    <Loader />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer position="bottom-center" autoClose={2000} newestOnTop closeOnClick pauseOnHover />
        </>
    );
};

export default ViewShareHistory;
